import { combineReducers } from "redux";
import dashboard from "../features/serviceadmin/dashboard/Slice";

const Dashboards = combineReducers({
  dashboard: dashboard,
});

export default Dashboards;
